import el from 'element-ui/src/locale/lang/el';
import { trIdReg } from '@/util/util';
let validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入译员ID'));
  } else if (value.search(trIdReg) < 0) {
    callback(new Error('译员ID格式有误'));
  } else if (value.length > 32) {
    callback(new Error('译员ID长度超过32个字符'));
  } else {
    callback();
  }
};
export const tableOption = {
  border: true,
  delBtn: false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  searchShowBtn: false,
  columnBtn: false,
  searchMenuSpan: 6,
  showClomnuBtn: false,
  searchSize: 'mini',
  menuWidth: 150,
  addBtn: false,
  editBtn: false,
  viewBtn: false,
  selection: true,
  reserveSelection: true,
  props: {
    label: 'label',
    value: 'value',
  },
  column: [
    {
      label: '译员ID',
      labelWidth: 60,
      width: 210,
      prop: 'trId',
      row: true,
      search: true,
      searchLabelWidth: 60,
      searchSpan: 5,
      editDisabled: true,
      rules: [
        {
          validator: validatePass,
          trigger: 'blur',
        },
      ],
      span: 24,
    },
    {
      label: '实习批次',
      width: 120,
      addDisplay: false,
      editDisplay: false,
      row: true,
      prop: 'batchNo',
      slot: true,
    },
    {
      label: '实习状态',
      width: 90,
      addDisplay: false,
      editDisplay: false,
      row: true,
      prop: 'status',
      search: true,
      searchLabelWidth: 75,
      searchSpan: 4,
      type: 'select',
      dicData: [
        {
          label: '实习中',
          value: 1,
        },
        {
          label: '实习结束',
          value: 2,
        },
      ],
    },
    {
      label: '语种能力',
      labelWidth: 120,
      prop: 'lanname',
      row: true,
      addDisplay: false,
      editDisplay: false,
    },
    {
      label: '译员昵称/姓名',
      labelWidth: 110,
      prop: 'nickName',
      slot: true,
      searchLabelWidth: 1,
      row: true,
      addDisplay: false,
      editDisplay: false,
    },
    {
      label: '已提交包数',
      prop: 'taskCount',
      width: 130,
      labelWidth: 0,
      type: 'number',
      minRows: 1,
      row: true,
      addDisplay: false,
      editDisplay: false,
    },
    {
      label: '已提交字数',
      prop: 'wordCount',
      width: 130,
      labelWidth: 0,
      type: 'number',
      addDisplay: false,
      editDisplay: false,
      row: true,
    },
  ],
};
